<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="handleSearch">Search</button>
                        </div>
                    </div>
                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                            <tr>
                                <th>SI</th>
                                <th>Share Holder Name</th>
                                <th>Designation</th>
                                <th>Shareholder Type</th>
                                <th>Total Share</th>
                                <th>Area</th>
                                <th>Whatsapp Number</th>
                                <th>Land Purchase Price</th>
                                <th>Land Registration Price</th>
                                <th>Booking Money</th>
                                <th>Land Purchase Date</th>
                                <th>File Opening Date</th>
                                <th>Customer Ref</th>
                                <th>Sales Person Name</th>
                                <th>Image</th>
                            </tr>
                            </thead>
                            <template v-if="!loading && reportData.length > 0">
                                <tbody>
                                <tr v-for="(data,index) in reportData">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ data.shareholder_name }}</td>
                                    <td>{{ data.designation_name }}</td>
                                    <td>{{ data.share_holder_type }}</td>
                                    <td>{{ data.total_share }}</td>
                                    <td>{{ data.area_name }}</td>
                                    <td>{{ data.whatsapp_number }}</td>
                                    <td>{{ data.land_purchase_price }}</td>
                                    <td>{{ data.land_registration_price }}</td>
                                    <td>{{ data.booking_money }}</td>
                                    <td>{{ data.land_purchase_date }}</td>
                                    <td>{{ data.file_opening_date }}</td>
                                    <td>{{ data.customer_reference_name }}</td>
                                    <td>{{ data.sales_person_name }}</td>
                                    <td>
                                        <img style="width: 60px; height: 60px" :src="data.image_path" alt="">
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                </tfoot>
                            </template>
                            <template v-if="!loading && reportData['data']?.length === 0">
                                <tr class="text-center">
                                    <td colspan="100" class="fw-bold fs-6 text-height">
                                        No Data Found
                                        <br>
                                        Please search by project.
                                    </td>
                                </tr>
                            </template>

                            <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue.vue";
import Table from "../Common/Table.vue";
import Breadcrumb from "../Common/Breadcrumb.vue";
import Unit from "../Settings/Unit/Unit.vue";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Unit, Breadcrumb, Table, ConfirmDialogue},
    data() {
        return {
            breadCrumb: ['Share Holder Deposit'],
            reportData: [],
            projects: [],
            costingItems: [],
            params: {
                project_id: '',
            },
            loading: false,
            exportLoading: false,

        }
    },
    methods: {
        downloadFile: function () {
            PrintService.print('/print/shareholder-deposit?project_id='+this.params.project_id);
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        handleSearch() {
            this.loading = true;
            ApiService.POST(ApiRoutes.Report + '/share-holder-deposit', this.params, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res.data;
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        }
    },
    created() {
        this.fetchProject();
    }
}
</script>

<style scoped>

</style>
